import { render, staticRenderFns } from "./learnMore.vue?vue&type=template&id=2a6b5e44&scoped=true&"
import script from "./learnMore.vue?vue&type=script&lang=js&"
export * from "./learnMore.vue?vue&type=script&lang=js&"
import style0 from "./learnMore.vue?vue&type=style&index=0&id=2a6b5e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b5e44",
  null
  
)

export default component.exports